export default "__VITE_ASSET__CpwM_XJM__"